import { render, staticRenderFns } from "./correct-question.vue?vue&type=template&id=30fcc5a5&scoped=true&"
import script from "./correct-question.vue?vue&type=script&lang=js&"
export * from "./correct-question.vue?vue&type=script&lang=js&"
import style0 from "./correct-question.vue?vue&type=style&index=0&id=30fcc5a5&scoped=true&lang=css&"
import style1 from "./correct-question.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fcc5a5",
  null
  
)

export default component.exports